<template>
    <v-card color="surface" width="300">
        <v-card-title>Search</v-card-title>
        <v-card-text>
            <v-form
                ref="form">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-if="show.code"
                            :label="$t('code')"
                            clearable
                            outlined
                            dense
                            hide-details="auto"
                            background-color="white"
                            @click:clear="form.code = ''"
                            @keypress.enter="submit"
                            v-model="form.code">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <p-date-picker
                            v-if="show.data_from"
                            :label="$t('date_from')"
                            outlined
                            dense
                            hide
                            background-color="white"
                            v-on="$listeners"
                            v-model="form.from">
                        </p-date-picker>
                    </v-col>
                    <v-col cols="12">
                        <p-date-picker
                            v-if="show.data_to"
                            :label="$t('date_to')"
                            outlined
                            dense
                            hide
                            background-color="white"
                            :min="form.from"
                        v-model="form.to">
                        </p-date-picker>
                    </v-col>
                    <v-col cols="12">
                        <auto-complete-search
                            v-if="show.user"
                            v-model="form.user_id"
                            :items.sync="users"
                            :label="$t('user')"
                            outlined
                            dense
                            hide-details="auto"
                            background-color="white"
                            :error="field.user.error"
                            :error-message="field.user.message"
                            @resetError="clearFieldMessageUser"
                            @update:search-input="fetchUsersData"
                            :loading="loading.user">
                        </auto-complete-search>
                    </v-col>
                    <v-col cols="12">
                        <v-select
                            :label="$t('state')"
                            v-model="form.status"
                            item-text="text"
                            :menu-props="{
                                down: true,
                                offsetY: true
                            }"
                            outlined
                            dense
                            hide-details="auto"
                            background-color="white"
                            :loading="loading.state"
                            @click="getJournalStatus"
                            item-value="value"
                            :items="status">
                        </v-select>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text  @click="submit">{{ $t("search") }}</v-btn>
            <v-btn text @click="$refs.form.reset()">{{ $t("reset") }}</v-btn>
        </v-card-actions>
    </v-card>
  
</template>

<script>
import PDatePicker from '@/components/common/PDatePicker';
import AutoCompleteSearch from './AutoCompleteSearch.vue';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'PSearchMenu',
    components: { PDatePicker, AutoCompleteSearch },
    props: {
        show: Object
    },
    data() {
        return {
            form: {
                user_id: '',
                to: '',
                from: '',
                code: ''
            },
            states: [],
            loading: {
                user: false,
                state: false
            },
            field: {
                user: {
                    message: '',
                    error: false
                }
            }
        }
    },
    computed: {
        ...mapState('administration/user', ["users"]),
        ...mapState('accounting/journalVoucher', ["status"])
    },
    methods: {
        ...mapActions('administration/user', ["fetchUsers"]),
        ...mapActions('accounting/journalVoucher', ['getJournalVoucherStatus']),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async fetchUsersData(val) {
            this.loading.user = true;
            this.clearFieldMessageUser();
            let result = await this.fetchUsers({ search: val });
            if(result.data.length == 0) {
                this.setMessageUser("Your search didn't match any record!");
            }
            this.loading.user = false;
        },
        async getJournalStatus() {
            try {
                if(this.status.length == 0 ) {
                    this.loading.state = true;
                    await this.getJournalVoucherStatus();
                    this.loading.state = false;
                } 
            } catch(e) {
                this.loading.state = false;
                this.setSnackBars({ color: 'error', message : e });
            }
        },
        setMessageUser(val) {
            this.field.user.error = true;
            this.field.User.message = val;
        },
        clearFieldMessageUser() {
            this.field.user.error = false;
            this.field.user.message = '';
        },
        submit() {
            if(this.form.user_id) this.form.user = this.users.find(each => each.id == this.form.user_id).name;
            this.$emit('search', this.form);
        }
    },
    created() {
        // this.getJournalStatus();
    }


}
</script>

<style>

</style>